import { IAppState } from 'src/store/types';

export const getLayoutsRequestData = (state: IAppState) => state.requests.layouts.data;
export const getLayoutsRequestLoading = (state: IAppState) => state.requests.layouts.isLoading;
export const getLayoutsRequestErrors = (state: IAppState) => state.requests.layouts.error;
